

import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { inventarioXID, listadoInventarioSelect, listadoInventarioTodo, listadoInventarioXProveedor } from "../../../services";





export const useInventarioXID = (id) => {
    const { data, isLoading } = useQuery({
        queryKey: ['invantarioXid', id], 
        queryFn: () => inventarioXID(id),
        enabled: !!id,
    });
    return { data, isLoading }
}



export const useInventarioXProvedor = (id) => {
    const { data, isLoading } = useQuery({
        queryKey: ['invantarioXproveedor', id], 
        queryFn: () => listadoInventarioXProveedor(id),
        enabled: !!id,
    });
    return { data, isLoading }
}



export const useInventarioSelect = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['inventarioSelect',], 
        queryFn: () => listadoInventarioSelect(),
    });
    return { data, isLoading }
}



export const useListInventarioTodo = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const page = parseInt(searchParams.get('page') || '0');
    const termino = searchParams.get('termino') || '';

    const { data, isLoading } = useQuery({
        queryKey: ['todo-inventario', { page, termino }], 
        queryFn: () => listadoInventarioTodo({ page, termino }),
    });


    const chagePage = useCallback((num) => {
        setSearchParams(prev => {
            prev.set('page', (num - 1).toString());
            return prev;
        }, { replace: true });
    }, [setSearchParams]);


    const chageTermino = useCallback((valor) => {
        setSearchParams(prev => {
            prev.set('termino', valor);
            prev.set('page', '0');
            return prev;
        }, { replace: true });
    }, [setSearchParams]);


    return {
        // Estados
        page,
        termino,
        // Métodos
        chagePage,
        chageTermino,
        data, isLoading,
    }
}
